import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=d6a563a2&scoped=true"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a563a2",
  null
  
)

export default component.exports